import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { HttpClient } from '@angular/common/http';
import { ProductWizardStore } from './product-wizard.store';
import { ProductWizard, productWizardFactory } from './product-wizard.model';
import { SettingsQuery } from '../settings/settings.query';
import { LanguageService } from '../../../core/services/language/language.service';
import { UserQuery } from '../user/user.query';
import { ClinicDetailQuery } from '../clinic-detail/clinic-detail.query';
import { ProductWizardQuery } from './product-wizard.query';
import { PickerController } from '@ionic/angular';
import { LibraryService } from '../../../core/services/library/library.service';

@Injectable({ providedIn: 'root' })
export class ProductWizardService {
    constructor(
        private productWizardStore: ProductWizardStore,
        private http: HttpClient,
        private settginsQuery: SettingsQuery,
        private languageService: LanguageService,
        private userQuery: UserQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private settingsQuery: SettingsQuery,
        private productWizardQuery: ProductWizardQuery,
        private pickerController: PickerController,
        private libraryService: LibraryService
    ) {}

    /*---------------------*/
    /** OPERACIONES ENTITY */

    /*---------------------*/

    add(productWizard: ProductWizard) {
        this.productWizardStore.add(productWizard);
    }

    update(id, productWizard: Partial<ProductWizard>) {
        this.productWizardStore.update(id, productWizard);
    }

    remove(id: ID) {
        this.productWizardStore.remove(id);
    }

    setProductsWizard(productsWizard: ProductWizard[]) {
        this.productWizardStore.set(productsWizard);
    }

    /*------------*/
    /** SERVICIOS */

    /*------------*/

    /**
     * Crea los servicioes a partir de los datos de la API y los carga en el Store
     */
    setProductsWizardByApi(productsWizard) {
        const productsWizardEntities = [];
        productsWizard.forEach((productWizard) => {
            productsWizardEntities.push(productWizardFactory(productWizard));
        });

        this.setProductsWizard(productsWizardEntities);
    }

    setProductChecked(productWizardId, checked: boolean) {
        this.productWizardStore.update(productWizardId, { checked });
    }

    setUnitsCart(productWizardId, units: number) {
        this.productWizardStore.update(productWizardId, { unitsCart: units });

        this.productWizardStore.update(productWizardId, {
            checked: units > 0,
        });
    }

    async getProductHtmlPage(producId: string): Promise<string> {
        const formData = new URLSearchParams();

        formData.append('SystemKey', this.settginsQuery.systemKeyURL);
        formData.append('Locale', this.languageService.getLocale());
        formData.append('ClientToken', this.userQuery.tokenId);
        formData.append('ClinicID', this.clinicDetailQuery.id);
        formData.append('ProductID', producId);
        formData.append('Cmd', 'c3001');

        const obj = {
            method: 'POST',
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded;charset=UTF-8',
            },
            body: formData,
        };

        return await fetch(this.settingsQuery.apiURL, obj)
            .then((res) => res.text())
            .then((result) => result);
    }

    resetStore() {
        this.productWizardStore.reset();
    }

    /** Flowwwer template */
    toggleProductChecked(productWizardId) {
        const checked = !this.productWizardQuery.getEntity(productWizardId)
            .checked;
        this.productWizardStore.update(productWizardId, {
            checked,
            unitsCart: checked ? 1 : 0,
        });
    }
}
